class HeDirectCheckout extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-direct-checkout-button]');
    this.label = this.querySelector('[data-direct-checkout-label]');
    this.error = this.querySelector('[data-direct-checkout-error]');

    this.button?.addEventListener('click', this.handleClick);
    this.availabilityObserver = new MutationObserver(this.syncAvailability);
    this.availabilityObserver.observe(this, { attributes: true, attributeFilter: ['hidden'] });
    this.syncAvailability();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    this.availabilityObserver?.disconnect();
  }

  handleClick = async () => {
    const form = this.closest('form');
    if (!form || !this.button) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput?.value) {
      this.showError('Selecciona una opción disponible antes de continuar.');
      return;
    }

    this.setLoading(true);
    this.showError('');

    try {
      const formData = new FormData(form);
      formData.delete('sections');
      formData.delete('sections_url');

      const response = await fetch(window.Theme?.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'No pudimos agregar el producto.');
      }

      const root = window.Shopify?.routes?.root || '/';
      window.location.assign(`${root}checkout`);
    } catch (error) {
      const message = error instanceof Error && error.message && error.message !== 'Failed to fetch'
        ? error.message
        : 'Ocurrió un error. Inténtalo nuevamente.';
      this.showError(message);
      this.setLoading(false);
    }
  };

  syncAvailability = () => {
    if (!this.button || this.button.getAttribute('aria-busy') === 'true') return;
    this.button.disabled = this.hasAttribute('hidden');
  };

  setLoading(isLoading) {
    if (!this.button) return;

    this.button.disabled = isLoading || this.hasAttribute('hidden');
    this.button.setAttribute('aria-busy', String(isLoading));
    if (this.label) this.label.textContent = isLoading ? 'Procesando…' : 'Pagar ahora';
  }

  showError(message) {
    if (!this.error) return;

    this.error.textContent = message;
    this.error.classList.toggle('hidden', !message);
  }
}

if (!customElements.get('he-direct-checkout')) {
  customElements.define('he-direct-checkout', HeDirectCheckout);
}
